import { UserRole } from '@lmc/ts-common'
import { Button, Icon } from '@lmc/ui-kit'
import { useRoleAccess } from 'components/AccessControl'

interface DownloadLogsCSVButtonProps {
  openModal: () => void
  disabled: boolean
  exporting: boolean
}

const DownloadLogsCSVButton = ({
  openModal,
  disabled,
  exporting,
}: DownloadLogsCSVButtonProps) => {
  const hasRolePermission = useRoleAccess(
    [UserRole.careHomeAdmin],
    [
      {
        i: 'download',
        this: 'Report',
      },
    ],
  )

  return (
    <Button
      onClick={openModal}
      disabled={disabled}
      disabledByPermission={!hasRolePermission}
      variant="default"
      icon={<Icon name="CloudDownloadOutlined" />}
    >
      {exporting ? 'Downloading...' : 'Export CSV'}
    </Button>
  )
}

export default DownloadLogsCSVButton
